// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Overlay__overlay___K5uAZ","closing":"Overlay__closing___1dcIT"};